import React, { useEffect, useState } from "react";
import Header from "@/components/Header/Header";
import BannerHome from "@/components/Banners/BannerHome";
import MobileHero from "@/components/Banners/MobileHero";
import ServicesWeOffer from "@/components/Home/ServicesWeOffer";
import WhatAlgebraCanDo from "@/components/Home/WhatAlgebraCanDo";
import Footer from "@/components/Footer/Footer";

import './App.css';

function App() {
  const [isMobile, setIsMobile] = useState(false);

  // Check if the screen is mobile size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="app-container">
      <Header />
      
      {/* Show different hero sections based on screen size */}
      {isMobile ? (
        <MobileHero />
      ) : (
        <div style={{ position: 'relative', zIndex: 5 }}>
          <BannerHome />
        </div>
      )}
      
      <div style={{ position: 'relative', zIndex: 4 }}>
        <ServicesWeOffer />
        <WhatAlgebraCanDo />
        <Footer />
      </div>
    </div>
  );
}

export default App;
